import CartTable from '@/components/CartTable';
import { SessionContext } from '@/context/SessionContext';
import { Song } from '@/javascript/library-objects';
import { Box, Button, Group, Stack, Text, useMantineTheme } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CartPage: React.FC = () => {
	const theme = useMantineTheme();
	const navigate = useNavigate();
	const session = useContext(SessionContext);
	if (session === undefined) {
		throw new Error("SongDetails must be a child of SessionContext.");
	}

	const [cartSongs, setCartSongs] = useState<Song[]>(session.songsInCart || [])

	useEffect(() => {
		setCartSongs(session.songsInCart || []);
	}, [session.songsInCart]);

	return (
		cartSongs.length > 0 ?
			(
				<Stack align={"center"} justify={"center"}>
					<Group
						align="center"
						justify="center"
						mt={30}
						style={{
							backgroundColor: theme.colors.blue[8],
							display: "flex",
							width: "50%",
							borderRadius: "20px"
						}}
						wrap="nowrap"
					>
						<Text
							p={20}
							fz={45}
							c={theme.colors.blue[0]}
							ta="center"
							style={{
								minWidth: 0,
							}}
						>
							Shopping Cart
						</Text>
					</Group>
					<CartTable />
					<Box
						mt={30}
						bg={theme.colors.blue[0]}
						bd={"3px solid blue.4"}
						p={30}
						style={{
							borderRadius: "10px",
							justifyContent: "center",
							boxShadow: "0px 0px 3px"
						}}>
						<Group wrap="nowrap" gap="xs" style={{ flex: 1, justifyContent: "flex-end" }}>
							<Button
								c={theme.colors.blue[0]}
								bg={theme.colors.blue[7]}
								onClick={() => ""}
							>
								Checkout
							</Button>
							<Button
								c={theme.colors.blue[9]}
								bg={theme.colors.blue[1]}
								onClick={() => navigate("/search")}
							>
								Continue Shopping
							</Button>
						</Group>
					</Box>
				</Stack>
			)
			:
			(
				<Stack justify={"center"} align={"center"}>
					<Group
						align="center"
						justify="center"
						mt={30}
						style={{
							backgroundColor: theme.colors.blue[8],
							display: "flex",
							width: "50%",
							borderRadius: "20px"
						}}
						wrap="nowrap"
					>
						<Text
							p={20}
							fz={45}
							c={theme.colors.blue[0]}
							ta="center"
							style={{
								minWidth: 0,
							}}
						>
							Shopping Cart
						</Text>
					</Group>
					<Box
						bg={theme.colors.blue[0]}
						h={500}
						w={"50%"}
						bd={"3px solid blue.4"}
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							borderRadius: "20px",
							boxShadow: "0px 0px 10px"
						}}>
						<Text ta="center" mb={20} fz={45} c={theme.colors.blue[7]}>
							Your Cart Is Empty
						</Text>
						<Button mt={20} ta="center" onClick={() => navigate("/search")}>
							Continue Shopping
						</Button>
					</Box>
				</Stack>
			)

	)
}

export default CartPage